import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DeleteAllArea = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'flex-end',
    margin: [
      `${defaultTheme.spacing.s} 0`,
      `${defaultTheme.spacing.s} 0`,
      `${defaultTheme.spacing.s} 0 0 0`,
      `${defaultTheme.spacing.s} 0 0 0`,
    ],
  }),
);
